<template>
  <div>
    <div class="header-img">
      <div class="header-text">
        <h1>诚信 精细 高效 务实</h1>
        <h2>Content Us</h2>
      </div>
    </div>
    <div class="crumbs-contain">
      <div>
        您的位置：
        <router-link tag="a" to="Home" class="home-title">首页</router-link
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ><router-link tag="a" to="Contact" class="new-name"
          >联系我们</router-link
        >
      </div>
    </div>
    <div class="pages-contain">
      <div class="relation-contain">
        <div class="relation-chunk">
          <div class="service-hotline">服务热线</div>
          <div class="phone">400-900-9023</div>
          <div class="underline1"></div>
          <div class="service-hotline">服务时间</div>
          <div class="date">周一到周五8:30-18:00</div>
          <div class="underline"></div>
        </div>
        <div class="relation-chunk">
          <div class="service-hotline">邮件方式</div>
          <div class="phone">atm8125@qh-service.com.cn</div>
          <div class="underline"></div>
          <div class="service-hotline">微信咨询</div>
          <div class="code-contain">
            <div class="subscription">
              <img
                src="../../../static/images/code1.png"
                alt="前海高扬订阅号"
              />
              <div>前海高扬订阅号</div>
            </div>
            <div class="tencent">
              <img src="../../../static/images/code2.png" alt="企业公众号" />
              <div>企业公众号</div>
            </div>
          </div>
        </div>
        <div class="relation-chunk">
          <div class="service-hotline">深圳市高扬生物科技有限公司</div>
          <!-- <div class="corporation">
            Shenzhen Gaoyang Biotechnology Co., Ltd.
          </div> -->
          <div class="site">
            地址：广东省深圳市宝安区新安街道兴东社区68区留仙三路2号鸿辉工业区2号厂房901A
          </div>
          <div class="site">
            电话：400-900-9023
          </div>
          <div class="site">手机：18300049333</div>
          <div class="site">邮箱：atm8125@qh-service.com.cn</div>
        </div>
      </div>
      <div class="gy-map">
        <iframe
          id="iframe"
          src="/static/map.html"
          frameborder="0"
          width="100%"
          height="325px"
          scrolling="no"
        ></iframe>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import bottom from "@/components/bottom";
export default {
  components: {
    bottom
  },
  methods: {}
};
</script>

<style scoped lang="less">
.header-img {
  width: 100%;
  height: 300px;
  background: url(../../../static/images/server8.png) no-repeat center center;
  .header-text {
    width: 1170px;
    margin: 0 auto;
    padding-top: 100px;
    h1 {
      color: #3488ea;
      font-size: 28px;
      font-weight: 300;
      line-height: 0;
    }
    h2 {
      color: #464646;
      font-size: 24px;
      opacity: 0.9;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
    }
  }
}
.crumbs-contain {
  width: 1170px;
  margin: 0 auto;
  padding: 30px 0;
  color: #666666;
  font-size: 12px;
  .home-title {
    cursor: pointer;
    color: #666666;
    &:hover {
      color: #3488ea;
    }
  }
  .new-name {
    color: #3488ea;
    cursor: pointer;
  }
  .fa-angle-right {
    margin: 0 5px;
  }
}
.pages-contain {
  width: 1170px;
  margin: 0 auto;
  padding: 50px 0 100px 0;
  .relation-contain {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .relation-chunk {
      width: 30%;
      .service-hotline {
        color: #444444;
        font-size: 16px;
        font-weight: 500;
        margin-top: 40px;
      }
      .phone {
        color: #464646;
        font-size: 18px;
        font-weight: normal;
        margin-top: 4px;
        font-family: "FZCYJ";
        letter-spacing: 1px;
      }
      .corporation {
        color: #444444;
        font-size: 12px;
        margin-top: 5px;
        margin-bottom: 40px;
      }
      .site {
        color: #999999;
        font-size: 12px;
        font-weight: 300;
        line-height: 24px;
        span {
          margin-left: 20px;
        }
      }
      .date {
        color: #666666;
        font-size: 14px;
        margin-top: 5px;
      }
      .code-contain {
        width: 100%;
        display: flex;
        flex-direction: row;
        margin-top: 5px;
        .subscription {
          width: 126px;
          display: flex;
          flex-direction: column;
          align-items: center;
          div {
            color: #999999;
            font-size: 14px;
            margin-top: 5px;
          }
          img {
            width: 126px;
            height: 126px;
          }
        }
        .tencent {
          width: 126px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 5px;
          div {
            color: #999999;
            font-size: 14px;
            margin-top: 5px;
          }
          img {
            width: 126px;
            height: 126px;
          }
        }
      }
    }
  }
  .gy-map {
    margin-top: 60px;
  }
}
.underline {
  width: 16px;
  height: 1px;
  background: #a5a5a5;
  margin-top: 57px;
}
.underline1 {
  width: 16px;
  height: 1px;
  background: #a5a5a5;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Contact/Contact.vue